export default {
  install(Vue, options) {
    console.log('Config Options geladen', options)
    Vue.prototype.$config = options;
  }
};



// WEBPACK FOOTER //
// ./src/plugins/config.js